// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.map-container {
  height: 100% !important;
  width: 100%;
}

.drawer-toggle-btn {
  position: absolute;
  top: 15px;
  left: 15px;
  z-index: 100;
}

#viewDiv {
  height: 100%;
  width: 100%;
}

.w-100 {
  width: 100%;
}

.w-95 {
  width: 95%;
}

.m-0 {
  margin: 0;
}

.m-1 {
  margin: 0.25rem;
}

.m-2 {
  margin: 0.5rem;
}

.mr-1 {
  margin-right: 1rem;
}

.ml-3 {
  margin-left: 3rem;
}

.ml--11 {
  margin-left: -11rem;
}

.mt-1 {
  margin-top: 1rem;
}

.mb-1 {
  margin-bottom: 0.5rem;
}

.mb-2 {
  margin-bottom: 1rem;
}

.pointer {
  cursor: pointer;
}

.legend-icon {
  min-width: 24px;
  text-align: center;
}

.legend-label {
  font-size: 12px;
}

.legend-position {
  position: absolute;
  bottom: 20px;
  left: 20px;
  z-index: 10;
}

.legend-container {
  display: flex;
  align-items: center;
  padding: 5px;
  background: white;
  border: 1px solid #ccc;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  width: fit-content;
}
.legend-container p {
  font-weight: bold;
}

.legend-position-small {
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 1;
}

.header-layers {
  position: absolute;
  top: 0.6rem;
  right: 20px;
  z-index: 1000;
  color: white;
}

.cb-content {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  line-height: 1;
}

.cb-content img {
  width: 15px;
  height: 15px;
  object-fit: cover;
  display: block;
  margin-left: -0.25rem;
}`, "",{"version":3,"sources":["webpack://./src/app/_@core/pages/home/home.component.scss"],"names":[],"mappings":"AAAA;EACE,uBAAA;EACA,WAAA;AACF;;AAEA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;AACF;;AAEA;EACE,YAAA;EACA,WAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,SAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,eAAA;EACA,kBAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,kBAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,wCAAA;EACA,kBAAA;AACF;AACE;EACE,iBAAA;AACJ;;AAGA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;AAAF;;AAGA;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,aAAA;EACA,YAAA;AAAF;;AAGA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;AAAF;;AAGA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,qBAAA;AAAF","sourcesContent":[".map-container {\n  height: 100% !important;\n  width: 100%;\n}\n\n.drawer-toggle-btn {\n  position: absolute;\n  top: 15px;\n  left: 15px;\n  z-index: 100;\n}\n\n#viewDiv {\n  height: 100%;\n  width: 100%;\n}\n\n.w-100 {\n  width: 100%;\n}\n\n.w-95 {\n  width: 95%;\n}\n\n.m-0 {\n  margin: 0;\n}\n\n.m-1 {\n  margin: 0.25rem;\n}\n\n.m-2 {\n  margin: 0.5rem;\n}\n\n.mr-1 {\n  margin-right: 1rem;\n}\n\n.ml-3 {\n  margin-left: 3rem;\n}\n\n.ml--11 {\n  margin-left: -11rem;\n}\n\n.mt-1 {\n  margin-top: 1rem;\n}\n\n.mb-1 {\n  margin-bottom: .5rem\n}\n\n.mb-2 {\n  margin-bottom: 1rem;\n}\n\n.pointer {\n  cursor: pointer;\n}\n\n.legend-icon {\n  min-width: 24px;\n  text-align: center;\n}\n\n.legend-label {\n  font-size: 12px;\n}\n\n.legend-position {\n  position: absolute;\n  bottom: 20px;\n  left: 20px;\n  z-index: 10;\n}\n\n.legend-container {\n  display: flex;\n  align-items: center;\n  padding: 5px;\n  background: white;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n  width: fit-content;\n\n  p {\n    font-weight: bold\n  }\n}\n\n.legend-position-small {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  z-index: 1;\n}\n\n.header-layers {\n  position: absolute;\n  top: 0.6rem;\n  right: 20px;\n  z-index: 1000;\n  color: white;\n}\n\n.cb-content {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  line-height: 1;\n}\n\n.cb-content img {\n  width: 15px;\n  height: 15px;\n  object-fit: cover;\n  display: block;\n  margin-left: -0.25rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
